import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import useAuth from '../../hooks/useAuth'
import useMisc from '../../hooks/useMisc'

export default function MaintenanceModeAlert() {
    const [showStatus, setShowStatus] = useState(false)
    const [statusMessage, setStatusMessage] = useState(
        'LiftOne Now is in Maintenance Mode',
    )

    const { user, impersonated: isImpersonated } = useAuth()
    const {
        isInMaintenanceModePage: maintenance,
        getMaintenanceModeForPage,
    } = useMisc()

    useEffect(() => {
        const ACTIVE_INTERVAL = 30 * 1000 // 30s while the user is interacting
        const IDLE_INTERVAL = 5 * 60 * 1000 // 5 min once the page is idle
        const IDLE_THRESHOLD = 60 * 1000 // treat as idle after 1 min of no activity

        let lastActivity = Date.now()
        let timeoutId

        const markActivity = () => {
            lastActivity = Date.now()
        }

        const activityEvents = [
            'mousemove',
            'mousedown',
            'keydown',
            'scroll',
            'touchstart',
        ]
        activityEvents.forEach(event =>
            window.addEventListener(event, markActivity, { passive: true }),
        )

        const scheduleNextCheck = () => {
            const isIdle = Date.now() - lastActivity > IDLE_THRESHOLD
            const delay = isIdle ? IDLE_INTERVAL : ACTIVE_INTERVAL
            timeoutId = setTimeout(() => {
                getMaintenanceModeForPage()
                scheduleNextCheck()
            }, delay)
        }

        getMaintenanceModeForPage()
        scheduleNextCheck()

        return () => {
            clearTimeout(timeoutId)
            activityEvents.forEach(event =>
                window.removeEventListener(event, markActivity),
            )
        }
    }, [])

    useEffect(() => {
        if (maintenance && isImpersonated) {
            const firstName = user?.first_name
            const lastName = user?.last_name
            let statusMessage = `LiftOne Now is in Maintenance Mode | You are viewing as ${firstName} ${lastName}`
            setShowStatus(true)
            setStatusMessage(statusMessage)
        } else {
            setShowStatus(false)
        }
    }, [maintenance, isImpersonated, user])

    return (
        <div
            className={clsx(
                'w-full flex z-200 justify-center items-center gap-2 px-3 transition-all duration-150 ease-in-out bg-yellow',
                showStatus ? 'max-h-6.5 py-1.5' : 'max-h-0 py-0',
            )}
            role="alert"
        >
            {showStatus && (
                <p className={clsx('font-medium text-xs text-black')}>
                    {statusMessage}
                </p>
            )}
        </div>
    )
}
